module.exports = __webpack_public_path__ + "media/application/images/ui/icon-phone-baac66e51d3d04a903f49dd81f93c196.png";